(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('PublishMessageController', PublishMessageController);

    PublishMessageController.$inject = ['PublishMessage', 'AlertService'];

    function PublishMessageController(PublishMessage, AlertService) {
        var vm = this;

        vm.save = function () {
            PublishMessage.publishMessage({topic:vm.topic, message: vm.message}, onSuccess, onError);

            function onSuccess() {
                vm.message="";
            }

            function onError() {
                AlertService.error("Message not sent");
            }
        }

    }
})();
